/** Guest-accessible sector dashboard (`/sector/:slug`), not list sub-routes. */
export function isPublicSectorOverviewPath(pathname: string): boolean {
  return /^\/sector\/[^/]+$/.test(pathname);
}
